import { BaseEntity, DefaultResponseWithData } from "./system";

export enum WatermarkPosition {
  BottomLeft = 0,
  BottomRight = 1,
  TopLeft = 2,
  TopRight = 3,
  Center = 4,
  Diagonal = 5,
  Cover = 6,

  // Square positions: places the logo in the corner of the largest centered square
  // that fits within the image — matching how platforms like Shopify, Google, and
  // Facebook crop portrait images into a square preview.
  SquareBottomLeft  = 7,
  SquareBottomRight = 8,
  SquareTopLeft     = 9,
  SquareTopRight    = 10,
}

export interface IPartImageSettings extends BaseEntity {
  removeBackgrounds: boolean;
  numberToRemove: number;
  replaceExistingImages: boolean;
  applyWatermarks: boolean;
  grayscale: boolean;
  position: WatermarkPosition;
  transparency: number; // 0 = fully opaque, 99 = maximum transparency
}

export interface IPartImageSettingsResponse extends DefaultResponseWithData<IPartImageSettings> { }
